module.exports = __webpack_public_path__ + "static/img/14000777.ed986994.png";